import { PillCRA as Pill } from '@prio365/prio365-react-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'react-jss';
import { PrioTheme } from '../../../../../../theme/types';

interface IncomingInvoiceNotRecognizedPillProps {
  className?: string;
}

export const IncomingInvoiceNotRecognizedPill: React.FC<
  IncomingInvoiceNotRecognizedPillProps
> = (props) => {
  //#region ------------------------------ Defaults
  const theme = useTheme<PrioTheme>();
  const { t } = useTranslation();
  //#endregion

  return (
    <Pill
      type="default"
      size="small"
      iconProp={['fal', 'triangle-exclamation']}
      style={{
        color: theme.colors.base.red.default,
        backgroundColor: theme.colors.base.red[20],
      }}
    >
      {t('accounting:incomingInvoices.notRecognized')}
    </Pill>
  );
};

export default IncomingInvoiceNotRecognizedPill;
